export default __webpack_public_path__ + "static/media/ChukwuaniHenrietta.da5e2247.jpeg";